var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 3.33341H15.0026C15.4446 3.33341 15.8686 3.50901 16.1811 3.82157C16.4937 4.13413 16.6693 4.55805 16.6693 5.00008V16.6667C16.6693 17.1088 16.4937 17.5327 16.1811 17.8453C15.8686 18.1578 15.4446 18.3334 15.0026 18.3334H5.0026C4.56058 18.3334 4.13665 18.1578 3.82409 17.8453C3.51153 17.5327 3.33594 17.1088 3.33594 16.6667V5.00008C3.33594 4.55805 3.51153 4.13413 3.82409 3.82157C4.13665 3.50901 4.56058 3.33341 5.0026 3.33341H6.66927M10.0026 9.16675H13.3359M10.0026 13.3334H13.3359M6.66927 9.16675H6.6776M6.66927 13.3334H6.6776M7.5026 1.66675H12.5026C12.9628 1.66675 13.3359 2.03984 13.3359 2.50008V4.16675C13.3359 4.62699 12.9628 5.00008 12.5026 5.00008H7.5026C7.04237 5.00008 6.66927 4.62699 6.66927 4.16675V2.50008C6.66927 2.03984 7.04237 1.66675 7.5026 1.66675Z",
    stroke: "#EA580C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardList);
export default __webpack_public_path__ + "static/media/ClipboardList.38d77b67478a3f585d3c91d46cab9f98.svg";
export { ForwardRef as ReactComponent };